import { SET_MY_ACCOUNT_POPUP_STATUS, SET_POPUP_NAVIGATION_STATUS, UPDATE_IS_MOBILE } from '../actions/types'

const initialState = {
	myProfileOpen: false,
	popupNavigationOpen: false,
	isMobile: window.innerWidth < 500
}

export default function (state = initialState, action) {
	switch(action.type) {
		case SET_MY_ACCOUNT_POPUP_STATUS: return {
			...state,
			myProfileOpen: action.payload
		}
		case SET_POPUP_NAVIGATION_STATUS: return {
			...state,
			popupNavigationOpen: action.payload
		}
		case UPDATE_IS_MOBILE: return {
			...state,
			isMobile: window.innerWidth < 500
		}
		default: return {
			...state
		}
	}
}